import dayjs from "dayjs";
/**
 * Converts a date string from "DD/MM/YYYY" format to a JavaScript Date object in "MM/DD/YYYY" format and additionally performs timezone clearing.
 *
 * @param date - The date string to convert. Can be in "DD/MM/YYYY" format or an ISO string.
 * @returns A JavaScript Date object if the conversion is successful, otherwise `null`.
 */
export const convertDDMMtoMMDD = (date: string) => {
  if (date && typeof date === "string" && date.includes("/")) {
    const parts = date.split("/");
    const day = parseInt(parts[0], 10);
    const month = parseInt(parts[1], 10);
    const year = parseInt(parts[2], 10);
    const convertedDate = new Date(year, month - 1, day);
    return convertedDate;
  } else if (date && typeof date === "string" && !date.includes("/")) {
    if (date.includes("T") && date.includes("Z")) {
      // Use dayjs to parse the date in a timezone-agnostic way
      const parsedDate = dayjs(date.split("T")[0]);
      return parsedDate.toDate();
    }
    return new Date(date);
  } else {
    return null;
  }
};
